import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    Text,
    Stack,
    Textarea,
    Tooltip,
    useClipboard,
    useColorModeValue,
    VStack,
    List,
    ListItem,
    ListIcon,
    UnorderedList,
    Link,
    Divider
} from '@chakra-ui/react'
import { CheckCircleIcon } from '@chakra-ui/icons';
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import nadal_bg from '../images/nadal_bg.png'

export default function PrivacyPolicy(props) {
    return (
        <Box p={5}>
            <Text>
                <Heading>Privacy Policy</Heading>
            </Text>
            <Text>
                This privacy policy applies to the SportMatchHK app (hereby referred to as "Application") for web and mobile devices that was created by SportMatchHK Development (hereby referred to as "Service Provider") as a Free service. This service is intended for use "AS IS".
            </Text>
            <Heading as="h4" size="md">
                Information Collection and Use
            </Heading>
            <Text>
                The Application collects information when you download and use it. This information may include information such as:
            </Text>
            <UnorderedList spacing={3}>
                {/* <ListItem>
                    Your device's Internet Protocol address (e.g. IP address)</ListItem>
                <ListItem>
                    The pages of the Application that you visit, the time and date of your visit, the time spent on those pages
                </ListItem>
                <ListItem>
                    The time spent on the Application
                </ListItem> */}
                <ListItem>
                    The operating system you use on your mobile device
                </ListItem>
            </UnorderedList>

            <Text>
                The Application collects your device's location, which helps the Service Provider determine your approximate geographical location and make use of in below ways:
            </Text>
            <UnorderedList spacing={3}>
                <ListItem>
                    Geolocation Services: The Service Provider utilizes location data to provide features such as personalized content, relevant recommendations, and location-based services.
                </ListItem>
                <ListItem>
                    Analytics and Improvements: Aggregated and anonymized location data helps the Service Provider to analyze user behavior, identify trends, and improve the overall performance and functionality of the Application.
                </ListItem>
                <ListItem>
                    Third-Party Services: Periodically, the Service Provider may transmit anonymized location data to external services. These services assist them in enhancing the Application and optimizing their offerings.
                </ListItem>
            </UnorderedList>
            <Text>
                The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
            </Text>
            <Text>
                For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to E-mail, username, first name, last name. The information that the Service Provider request will be retained by them and used as described in this privacy policy.
            </Text>

            <Heading as="h4" size="md">
                Third Party Access
            </Heading>
            <Text>
                Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways that are described in this privacy statement.
            </Text>

            Please note that the Application utilizes third-party services that have their own Privacy Policy about handling data. Below are the links to the Privacy Policy of the third-party service providers used by the Application:

            <Link href="https://policies.google.com/privacy">Google Play Services</Link>
            <Text>
                The Service Provider may disclose User Provided and Automatically Collected Information:
            </Text>
            <UnorderedList spacing={3}>
                <ListItem>
                    as required by law, such as to comply with a subpoena, or similar legal process;
                </ListItem>
                <ListItem>
                    when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;
                </ListItem>
                <ListItem>
                    with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
                </ListItem>
            </UnorderedList>

            <Heading as="h4" size="md">
                Opt-Out Rights
            </Heading>
            <Text>
                You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
            </Text>

            <Heading as="h4" size="md">
                Data Retention Policy
            </Heading>
            <Text>
                The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at <b><Link href="mailto:contactus@sportmatch.club">contactus@sportmatch.club</Link></b> and they will respond in a reasonable time.
            </Text>
            <Heading as="h4" size="md">
                Children
            </Heading>
            <Text>
                The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
            </Text>
            <Text>
                The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the case the Service Provider discover that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider (<b><Link href="mailto:contactus@sportmatch.club">contactus@sportmatch.club</Link></b>) so that they will be able to take the necessary actions.
            </Text>
            <Heading as="h4" size="md">
                Security
            </Heading>
            <Text>
                The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and maintains.
            </Text>
            <Heading as="h4" size="md">
                Changes
            </Heading>
            <Text>
                This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
            </Text>
            <Text>
                This privacy policy is effective as of 2024-07-01
            </Text>
            <Heading as="h4" size="md">

                Your Consent
            </Heading>
            <Text>
                By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
            </Text>
            <Heading as="h4" size="md">
                Contact Us
            </Heading>
            <Text>
                If you have any questions regarding privacy while using the Application, or have questions about the practices, please contact the Service Provider via email at <b><Link href="mailto:contactus@sportmatch.club">contactus@sportmatch.club</Link></b>.
            </Text>
            <Divider />
            {/* This privacy policy page was generated by <Link href="https://app-privacy-policy-generator.nisrulz.com/">App Privacy Policy Generator</Link>. */}
        </Box>
    )
}
